<template lang="">
  <div style="max-width: 100%">
    <Header
      title="Cancelar envios"
      subtitle="Agendamentos de PUSH WEB"
    ></Header>

    <template>
      <v-tabs
        v-model="tab"
        color='black'
        class="d-flex justify-start"
      >
        <v-tab class="mb-2" href="#schedule" name="schedule">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.45 2.5H18V1.75C18 1.336 17.664 1 17.25 1C16.836 1 16.5 1.336 16.5 1.75V2.5H7.5V1.75C7.5 1.336 7.164 1 6.75 1C6.336 1 6 1.336 6 1.75V2.5H3.55C2.144 2.5 1 3.644 1 5.05V20.45C1 21.856 2.144 23 3.55 23H20.45C21.856 23 23 21.856 23 20.45V5.05C23 3.644 21.856 2.5 20.45 2.5ZM3.55 4H6V4.75C6 5.164 6.336 5.5 6.75 5.5C7.164 5.5 7.5 5.164 7.5 4.75V4H16.5V4.75C16.5 5.164 16.836 5.5 17.25 5.5C17.664 5.5 18 5.164 18 4.75V4H20.45C21.029 4 21.5 4.471 21.5 5.05V7H2.5V5.05C2.5 4.471 2.971 4 3.55 4ZM20.45 21.5H3.55C2.971 21.5 2.5 21.029 2.5 20.45V8.5H21.5V20.45C21.5 21.029 21.029 21.5 20.45 21.5ZM6.75 10C6.199 10 5.75 10.449 5.75 11C5.75 11.551 6.199 12 6.75 12C7.301 12 7.75 11.551 7.75 11C7.75 10.449 7.301 10 6.75 10ZM17.25 10C16.699 10 16.25 10.449 16.25 11C16.25 11.551 16.699 12 17.25 12C17.801 12 18.25 11.551 18.25 11C18.25 10.449 17.801 10 17.25 10ZM11.997 10C11.446 10 10.997 10.449 10.997 11C10.997 11.551 11.446 12 11.997 12C12.548 12 12.997 11.551 12.997 11C12.997 10.449 12.548 10 11.997 10ZM6.75 14C6.199 14 5.75 14.449 5.75 15C5.75 15.551 6.199 16 6.75 16C7.301 16 7.75 15.551 7.75 15C7.75 14.449 7.301 14 6.75 14ZM17.25 14C16.699 14 16.25 14.449 16.25 15C16.25 15.551 16.699 16 17.25 16C17.801 16 18.25 15.551 18.25 15C18.25 14.449 17.801 14 17.25 14ZM11.997 14C11.446 14 10.997 14.449 10.997 15C10.997 15.551 11.446 16 11.997 16C12.548 16 12.997 15.551 12.997 15C12.997 14.449 12.548 14 11.997 14ZM6.75 18C6.199 18 5.75 18.449 5.75 19C5.75 19.551 6.199 20 6.75 20C7.301 20 7.75 19.551 7.75 19C7.75 18.449 7.301 18 6.75 18ZM17.25 18C16.699 18 16.25 18.449 16.25 19C16.25 19.551 16.699 20 17.25 20C17.801 20 18.25 19.551 18.25 19C18.25 18.449 17.801 18 17.25 18ZM11.997 18C11.446 18 10.997 18.449 10.997 19C10.997 19.551 11.446 20 11.997 20C12.548 20 12.997 19.551 12.997 19C12.997 18.449 12.548 18 11.997 18Z" fill="#161927"/>
</svg>

          <span class="pl-3 ff" style="text-transform: capitalize; font-size: 16px;">Agendamentos</span>
        </v-tab>
        <v-tab class="mb-2" href="#logs" name="logs">
          <svg width="20" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.7083 4.58333H11.4583C11.2053 4.58333 11 4.378 11 4.12499C11 2.86091 9.97242 1.83333 8.70833 1.83333H2.29167C1.02758 1.83333 0 2.86091 0 4.12499V17.875C0 19.1391 1.02758 20.1667 2.29167 20.1667H19.7083C20.9724 20.1667 22 19.1391 22 17.875V6.875C22 5.61091 20.9724 4.58333 19.7083 4.58333ZM1.375 17.875V4.12499C1.375 3.61991 1.78658 3.20833 2.29167 3.20833H8.70833C9.21342 3.20833 9.625 3.61991 9.625 4.12499C9.625 5.13608 10.4473 5.95833 11.4583 5.95833H19.7083C20.2134 5.95833 20.625 6.36991 20.625 6.875V8.25H6.41667C5.15258 8.25 4.125 9.27758 4.125 10.5417V17.875C4.125 18.3801 3.71342 18.7917 3.20833 18.7917H2.29167C1.78658 18.7917 1.375 18.3801 1.375 17.875ZM19.7083 18.7917H5.30842C5.43125 18.5112 5.5 18.2004 5.5 17.875V10.5417C5.5 10.0366 5.91158 9.625 6.41667 9.625H20.625V17.875C20.625 18.3801 20.2134 18.7917 19.7083 18.7917Z" fill="#4F5963"/>
</svg>
          <span class="pl-3 ff" style="text-transform: capitalize; font-size: 16px;">Logs</span>
        </v-tab>
      </v-tabs>
    </template>
    <div v-if="tab === 'schedule'">
      <schedule/>
    </div>
    <div v-if="tab === 'logs'">
      <LogsPushWeb />
    </div>  
  </div>
</template>
<script>
// Components
import Header from '@/components/Header.vue'
import LogsPushWeb from './LogsPushWeb'
import Schedule from './SchedulePushWeb'
// import { mapActions, mapMutations, mapState } from "vuex";

export default {
  components: {
    Header,
    LogsPushWeb,
    Schedule
  },
  methods: {
    // ...mapMutations("Push", {
    //   setRequestUri: "SET_REQUEST_URI",
    // }),
    changeEndpoint() {
      //  this.setRequestUri('/api/getMessages')
    }
  },
  async created() {
    await this.changeEndpoint();
  },

  data () {
    return {
      tab: 'schedule'
    }
  }
}
</script>
<style lang="" scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/Contents/ScheduleMessage/SchedulingMessage.vue